import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { ONE_SECOND_MS } from "#/config/time";

import { getServerTime } from "../time.service";

const MAX_ALLOWED_TIME_DIFFERENCE = ONE_SECOND_MS * 10;

export const useTimeSyncStatus = () => {
  const { data, dataUpdatedAt, isLoading, refetch } = useQuery({
    queryKey: ["getServerTime"],
    queryFn: getServerTime,
    refetchInterval: ONE_SECOND_MS * 30,
  });

  const result = useMemo(() => {
    if (!data || !dataUpdatedAt)
      return { shouldShowWarning: false, seconds: 0 };

    const difference = Math.abs(dataUpdatedAt - data.timestamp);

    return {
      shouldShowWarning: difference > MAX_ALLOWED_TIME_DIFFERENCE,
      seconds: Math.floor(difference / ONE_SECOND_MS),
    };
  }, [data, dataUpdatedAt]);

  return {
    data: result,
    isLoading,
    refetch,
  };
};
